import React from "react";
import {
  ConfirmDialog,
  ConfirmDialogProps,
} from "components/shared/ConfirmDialog";

type DeviceConfirmationDialogProps = ConfirmDialogProps;

const DeviceConfirmationDialog: React.FC<DeviceConfirmationDialogProps> = (
  props,
) => <ConfirmDialog {...props} />;

export default DeviceConfirmationDialog;
